import { AudioTrack } from "../contexts/AudioPlayerContext";
import listeningProgressService from "../services/listeningProgressService";
import { Mix } from "../types/Mix";

export const defaultMixArtwork =
  process.env.REACT_APP_DEFAULT_SHOW_IMAGE ||
  "https://www.eruptionradio.uk/site/wp-content/uploads/2024/01/logomain.png";

export const formatMixDate = (value?: string) => {
  if (!value) return "";
  const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const date = dateOnlyMatch
    ? new Date(
        Number(dateOnlyMatch[1]),
        Number(dateOnlyMatch[2]) - 1,
        Number(dateOnlyMatch[3])
      )
    : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const isLiveMix = (mix: Pick<Mix, "type">) =>
  String(mix.type || "").toLowerCase() === "live";

export const formatMixType = (type?: string) =>
  String(type || "mix").trim().toUpperCase();

export const getMixTypeBadgeClass = (type?: string) => {
  switch (String(type || "").toLowerCase()) {
    case "live":
      return "bg-red-500 text-white border-red-400/70 shadow-red-500/20";
    case "studio":
      return "bg-cyan-400 text-gray-950 border-cyan-300/80 shadow-cyan-400/20";
    default:
      return "bg-amber-300 text-gray-950 border-amber-200/80 shadow-amber-300/20";
  }
};

export const getMixPath = (mix: Mix) =>
  `/mixes/${encodeURIComponent(mix.slug || mix.mix_id)}`;

export const getMixArtwork = (mix: Mix) => mix.imageUrl || defaultMixArtwork;

export const createMixTrack = (mix: Mix): AudioTrack | null => {
  if (!mix.audioUrl) return null;

  const progress = listeningProgressService.getProgress(`mix:${mix.mix_id}`);
  const resumeFrom = progress?.positionSeconds ?? 0;

  return {
    id: `mix-${mix.mix_id}`,
    title: mix.title,
    artist: isLiveMix(mix) ? "" : mix.artist_name,
    url: mix.audioUrl,
    isLive: false,
    contentType: "mix",
    artwork: getMixArtwork(mix),
    mix,
    resumeFrom: resumeFrom > 0 ? resumeFrom : undefined,
  };
};
